import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams, useNavigate } from "react-router-dom"
import { updatePageState } from "../../../../../data/store/pageSlice"
import { ACL_IDENTIFIERS, APP_PAGES, ROUTE_PATH } from "../../../../../data/configs/constants"
import {
  getMembers,
  deleteMembers,
  transferTenant,
  getLiveChatConfigurations
} from "../../../../../data/store/overviewSlice"

import AddMember from "../../../../components/AddMember"
import ShowInvitedUsers from "../../../../components/ShowInvitedUsers"
import AclComponentWrapper from "../../../../components/AclComponentWrapper"
import CenteredPaperModal from "../../../../components/CenteredPaperModal"
import {
  Typography,
  Button,
  Tabs, Input, Table, Space, Tooltip,
  notification,
} from "antd";
import Notify, { notify } from "../../../../components/Notify"
const { TabPane } = Tabs;
const { Title, Text } = Typography;

const TeamMembers = () => {
  const { tenantId } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [email, setEmail] = useState("")
  const [openAddMemberModal, setOpenAddMemberModal] = useState(false)
  const [openModal, setOpenModal] = useState(false);
  const [defaultEditData, setDefaultEditData] = useState({});
  const [selectedTab, setSelectedTab] = useState("1");
  const memberList = useSelector((state) => state.overviewDetails.memberList)
  const currentPageAcl = useSelector((state) => state.pageDetails?.currentPageAcl);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  })
  const isWhiteLabeledDashboard = process.env.REACT_APP_WHITE_LABELED_APP === "true";

  useEffect(() => {
    dispatch(
      updatePageState({
        currentPage: APP_PAGES.TENANT_MEMBERS,
        currentSiderModule: APP_PAGES.TENANT_MEMBERS,
        showTenantHeader: true,
      })
    )
  }, [dispatch])


  useEffect(() => {
    dispatch(
      getMembers({
        tenantId,
      })
    )
    dispatch(getLiveChatConfigurations({ tenantId }))
  }, [dispatch, tenantId])

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      width: 200,
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      width: 150,
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      width: 200,
      render: (role) => (role === "tenantManager" ? "Bot Manager" : role === "owner" ? "Owner" : "")
    },
    {
      title: "Live Agent",
      dataIndex: "isLiveAgent",
      align: "center",
      width: 300,
      render: (isLiveAgent) => isLiveAgent ? <Text type="success">Active</Text> : <Text type="secondary">Inactive</Text>
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      width: 200,
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              icon={<i className="ri-edit-line" />}
              disabled={record.role === "owner"}
              onClick={() => {
                setOpenModal(true);
                setDefaultEditData(record);
              }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<i className="ri-delete-bin-7-line" />}
              danger
              disabled={record.role === "owner"}
              onClick={() => deleteMember(record._id, record.userId)}
            />
          </Tooltip>
        </Space>
      )
    },
  ];


  const deleteMember = (id, userId) => {
    dispatch(
      deleteMembers(
        id,
        tenantId,
        userId,
        () => {
          dispatch(
            getMembers({
              tenantId,
            })
          )
          notify.success({ message: `${email} has been removed from team` })
        }
      )
    )
  }


  const handleTabChanged = (value) => {
    setSelectedTab(value);
  }

  const handleModalClose = () => {
    setOpenModal(false);
    setOpenAddMemberModal(false)
  }

  const transferBot = () => {
    dispatch(
      transferTenant(tenantId, email, () => {
        navigate(ROUTE_PATH.DASHBOARD)
        notify.success({ message: `Bot successfully tranferred to ${email}` })
      })
    )
  }

  const handleInputChange = (event) => {
    setEmail(event.target.value)
  }

  return (
    <div style={{ padding: 16 }}>
      <Notify />
      <Title level={4} style={{ margin: 0 }}>Team Members</Title>
      <AclComponentWrapper componentAcl={currentPageAcl?.[ACL_IDENTIFIERS.ADD_TEAM_MEMBERS]}>
        <Tabs activeKey={selectedTab} onChange={handleTabChanged}>
          <TabPane tab="Members" key="1" />
          <TabPane tab="Invitations" key="2" />
          {!isWhiteLabeledDashboard && <TabPane tab="Transfer Ownership" key="3" />}
        </Tabs>

        {selectedTab === "1" && (
          <div style={{ padding: 5, marginTop: 2 }}>
            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <Title level={4} style={{ margin: 0 }}>Team members</Title>
              <Button icon={<i className="ri-add-line" />} onClick={() => {
                setOpenAddMemberModal(true)
              }}>
                Add member
              </Button>
            </Space>
            <Table
              columns={columns}
              dataSource={memberList}
              pagination={paginationModel}
              onChange={(pagination) => setPaginationModel(pagination)}
              rowKey={(record) => record._id}
              style={{ marginTop: 16 }}
            />
          </div>
        )}

        {selectedTab === "2" && (
          <div>
            <ShowInvitedUsers />
          </div>
        )}

        {selectedTab === "3" && !isWhiteLabeledDashboard && (
          <div>
            <Title level={4} style={{ margin: 0, marginBottom: 18 }}>Transfer Ownership</Title>
            <Input
              size="large"
              placeholder="Enter email address"
              value={email}
              onChange={handleInputChange}
              style={{ marginBottom: 16 }}
            />
            <Button
              type="primary"
              style={{ float: "right" }}
              size="large"
              disabled={!email}
              onClick={transferBot}
            >
              Transfer Bot to user
            </Button>
          </div>
        )}
      </AclComponentWrapper>

      <CenteredPaperModal open={openAddMemberModal} onClose={handleModalClose} >
        <AddMember onClose={handleModalClose} />
      </CenteredPaperModal>


      <CenteredPaperModal open={openModal} onClose={handleModalClose} >
        <AddMember defaultData={defaultEditData} onComplete={handleModalClose} />
      </CenteredPaperModal>
    </div>
  )
}

export default TeamMembers
